const ID_TOKEN_KEY = 'access_token';
const ID_REFRESH_TOKEN_KEY = 'refresh_token';

export const getToken = () => window.localStorage.getItem(ID_TOKEN_KEY);
export const getRefreshToken = () => window.localStorage.getItem(ID_REFRESH_TOKEN_KEY);

export const saveToken = ({ accessToken, refreshToken }) => {
  window.localStorage.setItem(ID_TOKEN_KEY, accessToken);
  window.localStorage.setItem(ID_REFRESH_TOKEN_KEY, refreshToken);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
  window.localStorage.removeItem(ID_REFRESH_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
